import React, { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { Input, Button } from "react-native-elements";
import Icon from "react-native-vector-icons/FontAwesome";
import { db } from "../firebase";

const AddChatScreen = ({ navigation }) => {
  React.useLayoutEffect(() => {
    navigation.setOptions({
      title: "Add a new chat",
    });
  }, [navigation]);

  const [chat_name, set_chat_name] = useState("");

  const create_chat_name = async () => {
    await db
      .collection("chats")
      .add({
        chat_name,
      })
      .then(() => navigation.goBack())
      .catch((error) => alert(error.message));
  };

  return (
    <View>
      <Input
        placeholder="Enter chat name"
        value={chat_name}
        onChangeText={(new_chat_name) => set_chat_name(new_chat_name)}
        leftIcon={
          <Icon name="wechat" type="antdesign" size={24} color="black" />
        }
      />
      <Button
        onPress={create_chat_name}
        title="Create Chat Name"
        disabled={!chat_name}
      />
    </View>
  );
};

export default AddChatScreen;

const styles = StyleSheet.create({});
